"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PWSSampleStatus = void 0;
var PWSSampleStatus;
(function (PWSSampleStatus) {
    PWSSampleStatus[PWSSampleStatus["New"] = 1] = "New";
    PWSSampleStatus[PWSSampleStatus["Analyzed"] = 3] = "Analyzed";
    PWSSampleStatus[PWSSampleStatus["Completed"] = 4] = "Completed";
    PWSSampleStatus[PWSSampleStatus["Invalidated"] = 5] = "Invalidated";
})(PWSSampleStatus = exports.PWSSampleStatus || (exports.PWSSampleStatus = {}));
//# sourceMappingURL=PWSSampleStatus.js.map